export const WAREHOUSE_TYPE = [
  {
    id: 1,
    name: 'Header',
    value: 1,
  },
  {
    id: 2,
    name: 'Line-Item',
    value: 2,
  },
  {
    id: 3,
    name: 'Line Details',
    value: 3,
  },
];

export const ITEM_TYPE = [
  {
    id: 0,
    name: 'Inventory',
    value: 0,
  },
  {
    id: 1,
    name: 'Service',
    value: 1,
  },
  {
    id: 2,
    name: 'Non Inventory',
    value: 2,
  },
  {
    id: 3,
    name: 'Group',
    value: 3,
  },
];

export const ACTION_TYPE = [
  {
    id: 0,
    name: 'Ignore',
    value: 0,
  },
  {
    id: 1,
    name: 'Warn',
    value: 1,
  },
  {
    id: 2,
    name: 'Confirm',
    value: 2,
  },
  {
    id: 3,
    name: 'Block',
    value: 3,
  },
];

export const ITEM_DETAILS_TYPES = [
  {
    id: 0,
    name: 'Normal',
    value: 0,
  },
  {
    id: 1,
    name: 'Serialised',
    value: 1,
  },
  {
    id: 2,
    name: 'Matrix',
    value: 2,
  },
];

export const BROKERAGE_TYPES = [
  {
    id: 0,
    name: 'None',
    value: 0,
  },
  {
    id: 1,
    name: 'Percentage',
    value: 1,
  },
  {
    id: 2,
    name: 'Quantity',
    value: 2,
  },
];

export const RAM_TYPE = [
  {
    id: 0,
    name: 'None',
    value: 0,
  },
  {
    id: 1,
    name: '1 GB',
    value: 1,
  },
  {
    id: 2,
    name: '2 GB',
    value: 2,
  },
  {
    id: 3,
    name: '3 GB',
    value: 3,
  },
  {
    id: 4,
    name: '4 GB',
    value: 4,
  },
  {
    id: 5,
    name: '5 GB',
    value: 5,
  },
  {
    id: 6,
    name: '6 GB',
    value: 6,
  },
  {
    id: 7,
    name: '7 GB',
    value: 7,
  },
  {
    id: 8,
    name: '8 GB',
    value: 8,
  },
  {
    id: 9,
    name: '9 GB',
    value: 9,
  },
  {
    id: 10,
    name: '10 GB',
    value: 10,
  },
  {
    id: 11,
    name: '11 GB',
    value: 11,
  },
  {
    id: 12,
    name: '12 GB',
    value: 12,
  },
  {
    id: 13,
    name: '13 GB',
    value: 13,
  },
  {
    id: 14,
    name: '14 GB',
    value: 14,
  },
  {
    id: 15,
    name: '15 GB',
    value: 15,
  },
  {
    id: 16,
    name: '16 GB',
    value: 16,
  },
  {
    id: 17,
    name: '17 GB',
    value: 17,
  },
  {
    id: 18,
    name: '18 GB',
    value: 18,
  },
  {
    id: 19,
    name: '19 GB',
    value: 19,
  },
  {
    id: 20,
    name: '20 GB',
    value: 20,
  },
  {
    id: 21,
    name: '21 GB',
    value: 21,
  },
  {
    id: 22,
    name: '22 GB',
    value: 22,
  },
  {
    id: 23,
    name: '23 GB',
    value: 23,
  },
  {
    id: 24,
    name: '24 GB',
    value: 24,
  },
];

export const STORAGE_TYPE = [
  {
    id: 0,
    name: 'None',
    value: 0,
  },
  {
    id: 1,
    name: '16 GB',
    value: 16,
  },
  {
    id: 2,
    name: '32 GB',
    value: 32,
  },
  {
    id: 3,
    name: '64 GB',
    value: 64,
  },
  {
    id: 4,
    name: '128 GB',
    value: 128,
  },
  {
    id: 5,
    name: '256 GB',
    value: 256,
  },
  {
    id: 6,
    name: '512 GB',
    value: 512,
  },
  {
    id: 7,
    name: '1 TB',
    value: 1024,
  },
  {
    id: 8,
    name: '2 TB',
    value: 2048,
  },
];

export const NETWORK_TYPE = [
  {
    id: 0,
    name: 'None',
    value: 0,
  },
  {
    id: 1,
    name: '3G',
    value: 1,
  },
  {
    id: 2,
    name: '4G',
    value: 2,
  },
  {
    id: 3,
    name: '5G',
    value: 3,
  },
  {
    id: 4,
    name: 'LTE',
    value: 4,
  },
];
